module.exports = __webpack_public_path__ + "img/reef.921764ee.svg";